// extracted by mini-css-extract-plugin
export default {"modalHead":"ServiceDropdown_modalHead__XjYLo","btnPrimary":"ServiceDropdown_btnPrimary__artoS"};